import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const partners = {
    namespaced: true,
    state: {
        partnersList: [],
        partnerApiList: [],
    },
    getters: {
        getPartnersList (state) {
            return state.partnersList;
        },
        getPartnerApiList (state) {
            return state.partnerApiList;
        },
    },
    mutations: {
        setPartnersList (state, partners) {
            state.partnersList = partners;
        },
        setPartnerApiList (state, apis) {
            state.partnerApiList = apis;
        },
    },
    actions: {
        async fetchPartnersList ({ dispatch, commit }) {
            const url = '/partners';
            try {
                const partners = await axios.get(url);
                commit('setPartnersList', partners.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your partners list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async addNewPartner ({ dispatch }, payload) {
            const url = '/partners';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your new partner.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchPartnerApiList ({ dispatch, commit }, payload) {
            const url = `partners/${payload.partnerId}/endpoints`;
            try {
                const partnerApi = await axios.get(url);
                commit('setPartnerApiList', partnerApi.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your partner Api list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async addNewPartnerApi ({ dispatch }, payload) {
            const url = `partners/${payload.partnerId}/endpoints`;
            try {
                 await axios.post(url, payload.apiDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your new partner.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
